import { Alert, Table, Typography } from '@mui/material';
import React from 'react';
import TabelleEntries from '../../../TabelleEntries';
import useBSSLogger from "../../../../hooks/useBSSLogger";
import __t from '../../../../lib/traduzioni';
import { format, parse } from 'date-fns';
import { TableRow } from '@mui/material';
import { TableCell } from '@mui/material';
import { Stack } from '@mui/material';
import { useTheme } from '@emotion/react';
import { useMediaQuery } from '@mui/material';
import { orderHrefBuilder } from '../utils';
import { Link } from '@mui/material';
import { Chip } from '@mui/material';
import { Badge } from '@mui/material';
import { IconButton } from '@mui/material';
import { ExpandMore } from '@mui/icons-material';
import { Button } from '@mui/material';
import { useState } from 'react';
import { ExpandLess } from '@mui/icons-material';
import { List } from '@mui/material';
import { ListItem } from '@mui/material';
const {logger} = useBSSLogger();

//tab con i dati di fatturazione legati all'ordine
const TabPagamenti = ({ ordine, tabObj }) => {

    const { pagamenti = [] } = ordine;

    const [mostraOrdiniCoinvolti, setMostraOrdiniCoinvolti] = useState(pagamenti.reduce((obj, pagamento) => {
        obj[pagamento.canale.label] = false;
        return obj;
    }, {}));

    const theme = useTheme();
    const isPhone = useMediaQuery(theme.breakpoints.down("md"))

    const labelCanale = pagamento => `${pagamento.canale.label} ${__t("del")} ${format(parse(pagamento.datapagamenti, 'yyyy-MM-dd HH:mm:ss.SSS', new Date()), 'dd/MM/yyyy')}`

    const tabelle = pagamenti.reduce((obj, pagamento) => ({
        ...obj,
        [labelCanale(pagamento)]: {
            [__t("transazione")]: pagamento.numeroTransazione,
            [__t("importo")]: <Typography variant={"h6"}>€ {pagamento.importo.toFixed(2)}</Typography>
        }
    }), {})
    
    return (
        <>
            <Typography variant={"body1"}>
                {/* <pre>{JSON.stringify(tabelle, null, 2)}</pre> */}

                {(Array.isArray(pagamenti) && (pagamenti.length > 0)) ? (
                    <TabelleEntries 
                        wrapped 
                        tabelle={tabelle} 
                        dataSource={pagamenti}
                        
                        customRowHeader={({
                            defaultStyles,
                            tabelle,
                            datiTabella,
                            indiceTabella,
                            dataSource
                        }) => {

                            const pagamento = dataSource[indiceTabella];
                            const label = labelCanale(pagamento);
                            const {ordini = {}} = pagamento
                            const {codiceordine: codiceordineCorrente} = ordine;
                            const altriordini = Object.entries(ordini)
                                .filter(([idordine, codiceordine]) => codiceordine.toUpperCase() !== codiceordineCorrente.toUpperCase())  
                                .reduce((arr, [id, codiceordine], indice) => {
                                    arr[indice] = {id, codiceordine};
                                    return arr;
                                }, [])  
                            logger.debug("altri ordini coinvolti", ordini, altriordini)

                            const title = (
                                <Typography variant={"h6"} sx={{textAlign: "left"}}>
                                    {label} 
                                </Typography>
                            )

                            const actionToggle = altriordini.length ? (
                                <Button variant="contained" onClick={e => setMostraOrdiniCoinvolti({
                                    ...mostraOrdiniCoinvolti,
                                    [pagamento.canale.label]: !mostraOrdiniCoinvolti[pagamento.canale.label]
                                })}>
                                    {!mostraOrdiniCoinvolti[pagamento.canale.label] ? (
                                        <ExpandMore />
                                    ): <ExpandLess />}
                                </Button> 
                            ) : "";
                                                            
                            return (
                                <>
                                    <TableRow sx={defaultStyles.rowHeaderStyle}>
                                        {!isPhone ? (
                                            <>
                                                <TableCell>
                                                    {title}                                                    
                                                </TableCell>
                                                <TableCell align={"right"}>
                                                    {actionToggle}
                                                </TableCell>
                                            </>
                                        ): (
                                            <TableCell colSpan={2}>
                                                <Stack>
                                                    {title}
                                                </Stack>
                                                {actionToggle}
                                            </TableCell>                                                   
                                        )}
                                        
                                    </TableRow>     
                                    {mostraOrdiniCoinvolti[pagamento.canale.label] && (
                                        <TableRow colSpan={2}>
                                            <OrdiniCoinvolti altriordini={altriordini} />
                                        </TableRow> 
                                    )}
                                    
                                </>                           
                            )
                        }}   
                        
                    />
                ): (
                    <Alert severity='info'>
                        {__t("nessunpagamento")}
                    </Alert>
                )}
                
            </Typography>

        </>
    );
};

const OrdiniCoinvolti = ({altriordini}) => {
    
    return (
        <>
            <List sx={{p: 2}} subheader={`${__t("altriordinicoinvolti")}: ${altriordini.length}`}>
                {altriordini.map((altroordine, indice) => {

                    return (
                        <ListItem key={indice}>
                            <Link href={orderHrefBuilder({ordine: altroordine})}>
                                {altroordine.codiceordine}
                            </Link>
                        </ListItem>
                        
                    )})}
            </List>        
        </>
    )
}

export default TabPagamenti;